module.exports = __webpack_public_path__ + "static/media/layer_2.3343ff65.png";